import { Button } from "@mui/material";

const TimeSlotSelector = ({ selectedTime, onTimeSlotChange, timeSlots }) => {
  const handleTimeSlotClick = (timeSlot) => {
    if (selectedTime !== timeSlot.startTime) {
      onTimeSlotChange({ id: timeSlot.id, time: timeSlot.startTime });
    }
  };

  return (
    <div className="d-flex gap-3 flex-wrap mt-2 mb-2">
      {timeSlots?.length > 0 ? (
        timeSlots?.map((time) => (
          <Button
            key={time.id}
            variant={selectedTime === time.startTime ? "contained" : "outlined"}
            color={selectedTime === time.startTime ? "primary" : "secondary"}
            onClick={() => handleTimeSlotClick(time)}
            sx={{
              minWidth: "80px",
              backgroundColor:
                selectedTime === time.startTime ? "#2EA286" : "#F6F6F6",
              color: selectedTime === time.startTime ? "#fff" : "#000",
              "&:hover": {
                backgroundColor:
                  selectedTime === time.startTime ? "#2EA286" : "#E0E0E0",
              },
            }}
          >
            {time.startTime}
          </Button>
        ))
      ) : (
        <>
          <div className="d-flex justify-content-center align-items-center">
            <span className="d-flex justify-content-center">
              No Slots Available
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default TimeSlotSelector;
